class MainCart extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('cart:bundled-sections', this.onPrepareBundledSections.bind(this));

    // NEW CODE for Terms of Service validation
    this.addEventListener('submit', (e) => {
      const form = e.target;
      if (form.matches('form.cart__form')) {
        const termsCheckbox = document.getElementById('agree_terms');
        const termsError = document.getElementById('terms_error');

        if (termsCheckbox && !termsCheckbox.checked) {
          e.preventDefault();
          e.stopImmediatePropagation();
          termsError.style.display = 'block';
          termsCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (termsCheckbox && termsCheckbox.checked) {
          termsError.style.display = 'none';
        }
      }
    });
  }

  get sectionId() {
    return this.getAttribute('data-section-id');
  }

  onPrepareBundledSections(event) {
    event.detail.sections.push(this.sectionId);
  }
}
customElements.define('main-cart', MainCart);
